import { CheckCircleOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { useTranslation } from 'translations/hooks';
import { StatusTag } from 'ui/components/status-tag';
import { Content } from 'ui/components/content';
import type { UpdatableSegmentStatus } from 'business/receipt/constants';
import { Routes } from 'business/router/constants';
import { useEffect } from 'react';

export const ReceiptSuccessPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get('serialNumber');
  const segmentType = searchParams.get('segmentType');
  const status = searchParams.get('status') as UpdatableSegmentStatus;

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(Routes.Receipt);
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Content>
      <div className="flex w-full flex-1 flex-col items-center justify-center gap-y-6 px-12 text-center">
        <CheckCircleOutlined className="text-2xl" />
        <h1 className="max-w-xs text-lg">
          {t('receipt.success.segmentUpdated')}
        </h1>
        <Card className="w-full" styles={{ body: { padding: '12px' } }}>
          <div className="flex justify-between">
            <div>{serialNumber}</div>
            <div>{segmentType}</div>
            <StatusTag status={status} />
          </div>
        </Card>
      </div>

      <Link to={Routes.Receipt} className="w-full py-4">
        <Button type="primary" className="w-full" htmlType="submit">
          {t('common.validate')}
        </Button>
      </Link>
    </Content>
  );
};
